import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const useNewCatalogPageBannerExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.NewCatalogPageBanner,
        AmplitudeVariants.NewCatalogPageBanner.Treatment
    );
